<template>
  <div class="inline-flex gap-3 justify-between w-full items-center" @click="changeLocation">
    <div class="inline-flex gap-3">
      <div class="flex flex-col gap-0.5 cursor-pointer">
        <div class="inline-flex items-center gap-2">
          <h5 class="font-semibold text-nowrap dark:text-gray-700">Your Location</h5>
          <V3ImageComponent src="icons/chevron-down.png" class="h-4 w-4"/>
        </div>
        
        <p class="line-clamp-2 text-xs text-gray-500">{{ addressText }}</p>
      </div>
    </div>
    <!-- <V3ImageComponent src="icons/chevron-down.png" class="h-4 w-4"/> -->
    <!-- <a class="text-sm text-primary cursor-pointer font-semibold" v-if="$device.isMobile" @click="changeLocation">
      Change
    </a>
    <a class="text-sm text-primary cursor-pointer font-semibold" v-else @click="changeLocation">
      <V3ImageComponent src="icons/chevron-down.png" class="h-4 w-4"/>
    </a> -->
  </div>
</template>

<script setup>
import { V3ModalComponent, V3PopupComponent } from '#components';
import { popupBackHandler } from '@/composables/popupBackHandler'
const { gtag } = useGtag();
import { onBeforeRouteLeave } from 'vue-router'
const auth = useAuth();
const isModalOpen = ref(false);
let historyCount = 0
// const route = useRoute();
const isAuthenticated = auth && auth.access_token;
const userData = isAuthenticated ? {
    user_name: auth.user.first_name,
    user_phone: auth.user.phone,
    user_email: auth.user.email,
  } : {
    user_name: null,
    user_phone: null,
    user_email: null
  };
const location = useLocation();
const { addressText } = useAddressText(location);
const { isMobile } = useDevice();
const slideover = useSlideover();
const modal = useModal();
const { isPopupOpen, openPopup, closePopup } = popupBackHandler()
const changeLocation = async () => {
  gtag('event', 'cta_event', {
    action: 'click',
    cta_name: 'your location',
    previous_location: addressText.value,
    ...userData,
  });
  if(!isAuthenticated){
      if (isMobile) {
      slideover.open(V3PopupComponent, {
        component: 'location',
        onSuccess: () => {window.location.reload(true) },
        onClose: () => {slideover.close();}
      });
      // openPopup();
    } else {
      modal.open(V3ModalComponent, {
        component: 'location',
        onSuccess: () => { window.location.reload(true) },
        onClose: () => {modal.close();}
      });
      // openPopup();
    }
    // if(route?.fullPath) {
    //   await navigateTo({ path: '/location-finder', query: { url: encodeURIComponent(route?.fullPath) } });
    // }
  }else{
    navigateTo({ path: '/select-location', query: { from: 'home' } })
  }
};

// watch(isPopupOpen, (newVal) => {
//   if(!newVal) {
//    slideover.close();
//    modal.close();
//   }
// })
</script>
